import React from "react";
import { TbCalendarTime, TbFileText, TbMap2, TbPencil } from "react-icons/tb";
import {
  Box,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Icon,
  InputField,
  Row,
  SelectField,
  Switchbox,
  Typography,
} from "../../../ppui";
import {
  Card,
  CardHeading,
  CustomTable,
  CustomTableBody,
  CustomTableHeader,
  OrganizationBx,
  OrganizationEmDetails,
  Td,
  Th,
  Tr,
} from "../../style";
import { TAX_INPUT_FIELDS } from "./ptax-constant";

const StatutoryPtaxStatusView = ({
  pTaxViewData,
  getInputFieldPropsFn,
  stateList,
  pTaxListInfo,
  handleDisableAllPTaxFn,
  esiInputs,
  createUpdateLoading,
  handleSubmitFn,
  setOpenPtaxModal,
  handleOpenStatutoryPtaxModal,
  handleCloseStatutoryPtaxModal,
  pTaxInfo }) => {
  return (
    <>
      <Card>
        <CardHeading Divider>
          <Box>
            Professional Tax Status
          </Box>
          <FabButton
            size="sm"
            icon={<TbPencil />}
            onClick={handleOpenStatutoryPtaxModal}
            variant="filled"
            shape="box"
          />
        </CardHeading>
        <OrganizationEmDetails>
          <OrganizationBx>
            <Icon size={"lg"}>
              <TbFileText /> {/* Suitable for P-Tax (EC) Code */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                P-Tax (EC) Code
              </Typography>
              <Typography variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize">
                {pTaxViewData?.ptax_ec_code || 'N/A'}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbFileText /> {/* Suitable for P-Tax (RC) Code */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                P-Tax (RC) Code
              </Typography>
              <Typography variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize">
                {pTaxViewData?.ptax_rc_code || 'N/A'}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbMap2 /> {/* Suitable for State */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                State
              </Typography>
              <Typography variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize">
                {stateList?.find((ele) => ele?.id === pTaxViewData?.state)?.name || 'N/A'}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbCalendarTime /> {/* Suitable for Financial Year */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Financial Year
              </Typography>
              <Typography variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize">
                {pTaxListInfo?.ptaxYearList?.find((ele) => ele?.id === pTaxViewData?.financial_year)?.name || 'N/A'}
              </Typography>
            </Box>
          </OrganizationBx>
        </OrganizationEmDetails>


        {(pTaxViewData.status) && <>
          <Divider gap={20} />
          <Typography variant="h5">Professional Tax Slab</Typography>
          <Row>
            <Col sm={12} md={6}>
              <CustomTable>
                <CustomTableHeader>
                  <Tr>
                    <Th>
                      <Typography variant="body1" mb={"0"}>
                        MONTHLY GROSS SALARY (₹)
                      </Typography>
                    </Th>

                    <Th>
                      <Typography variant="body1" mb={"0"}>
                        MONTHLY TAX AMOUNT (₹)
                      </Typography>
                    </Th>
                  </Tr>
                </CustomTableHeader>

                <CustomTableBody>

                  {
                    pTaxInfo?.tax_cal
                      ?.map(it => (
                        <Tr key={it?.salary}>
                          <Td>
                            <Typography variant="body1" mb={"0"}>
                              {it?.min_salary} - {it?.max_salary || "Above"}
                            </Typography>
                          </Td>
                          <Td>
                            <Typography variant="body1" mb={"0"}>
                              {it?.tax_amount}
                            </Typography>
                          </Td>
                        </Tr>
                      ))
                  }
                </CustomTableBody>
              </CustomTable>
            </Col>
          </Row>
        </>}
      </Card>

      <Dialog
        title="P-Tax Status"
        closeButton={true}
        fullWidth
        maxWidth="xs"
        buttonName={"Update"}
        open={setOpenPtaxModal}
        onClose={handleCloseStatutoryPtaxModal}
        onSubmit={handleSubmitFn}
        separator
        loading={createUpdateLoading}
        footer={
          <>
            <Box mr="auto">
              <Switchbox
                color="Primary"
                size="lg"
                label={`${!esiInputs.status ? "Enable" : "Disable"}  P-Tax `}
                checked={esiInputs.status} onChange={handleDisableAllPTaxFn}
              />
            </Box>
          </>
        }
      >
        <Flex gap={20} direction={"column"}>
          <InputField
            {...getInputFieldPropsFn(TAX_INPUT_FIELDS.ptax_ec_code.name)}
            disabled={!esiInputs?.status}
          />
          <InputField
            {...getInputFieldPropsFn(TAX_INPUT_FIELDS.ptax_rc_code.name)}
            disabled={!esiInputs?.status}
          />
          <SelectField
            {...getInputFieldPropsFn(TAX_INPUT_FIELDS.state.name)}
            options={stateList}
            disabled={!esiInputs?.status}
          />
          <SelectField
            {...getInputFieldPropsFn(TAX_INPUT_FIELDS.financial_year.name)}
            options={pTaxListInfo.ptaxYearList || []}
            disabled={!esiInputs?.status}
          />
        </Flex>
      </Dialog>
    </>
  );
};

export default StatutoryPtaxStatusView;
